import comp from "./AILanguageSelection";
export default comp;
